export enum NewsletterStatus {
  Draft = 'DRAFT',
  Sent = 'SENT',
}
